import { useMsal } from '@azure/msal-react';
import { useMemo, useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import NoPermsisonRoute from '../Components/NoPermssion/NoPermssion';
import NotFoundRoute from '../Components/NotFound/NotFound';
import { validateRole } from '../Helpers/RolesHelper';
import { ApplicationRoutes } from '../Store/ApplicationRoutes';
import NoAccountManagerPermsisonRoute from '../Components/NoAccountManagerPermssion/NoAccountManagerPermssion';
import { SharedContext } from '../StateManagement/Reducers/SharedReducer';

const AppRoutes = () => {
    const { accounts } = useMsal();
    const { state: { accountManagerDetails } } = useContext(SharedContext);

    return (
        <Routes>
            {useMemo(() => (
                <>
                    {Object.values(ApplicationRoutes()).map(route => {
                        let hasPermission = validateRole(accounts[0].idTokenClaims!.groups, route.roles);

                        let noAccountManager = route.requireAccountManager && accountManagerDetails.id === null;

                        if (!hasPermission) {
                            return <Route key={route.name} path={route.route} element={<NoPermsisonRoute />}></Route>
                        }

                        if (noAccountManager) {
                            return <Route key={route.name} path={route.route} element={<NoAccountManagerPermsisonRoute />}></Route>
                        }

                        return (
                            <Route key={route.name} path={route.route} element={route.component}></Route>
                        )

                    })}
                    <Route key={"not-found"} path={"*"} element={<NotFoundRoute />}></Route>
                </>
            ), [ApplicationRoutes, accountManagerDetails])}
        </Routes>
    )
}

export default AppRoutes;